import httpClient, { paramsToString } from '@/services/http/httpClient'
import billmaHttpClient from '@/services/http/billmaHttpClient'
import serializeObject from '@/utils/serializeObject'

export const apiGetSinisters = (
    sinisterId,
    complementaryRef,
    sinisterStatus,
    page
) => {
    const params = {
        sinister_id: sinisterId,
        complementary_ref: complementaryRef,
        status_id: sinisterStatus,
        page
    }

    const hasParams = sinisterId || complementaryRef || sinisterStatus || page
    return httpClient
        .get(`sinister/${hasParams ? '?' + serializeObject(params) : ''}`)
        .then((data) => data)
        .catch((error) => Promise.reject(error))
}

export const apiGetSinister = (sinisterId) => {
    const params = new URLSearchParams()
    params.append('sinister_id', sinisterId)
    return httpClient
        .get(`sinister/address${paramsToString(params)}`)
        .then((data) => data)
}

export const apiPostSinister = (
    sinisterId,
    zipCode,
    moreThanTwoYears,
    propertyType,
    residentType,
    lat,
    lon,
    addressSin,
    observationsSin
) => {
    return httpClient.post('sinister/address', {
        sinister_id: sinisterId,
        zip_code: zipCode,
        more_than_two_years: moreThanTwoYears,
        real_estate: propertyType,
        declarant: residentType,
        lat: lat,
        lon: lon,
        address: addressSin,
        observations: observationsSin
    })
}

export const billmaApiPutClaim = ({ sinisterId, externalId, documents }) => {
    return billmaHttpClient.post(`/bridge/api/claims/${sinisterId}/update`, {
        externalId: externalId,
        documents: documents
    })
}